export default "__VITE_ASSET__06ac7537__"